<template>
    <div class="bg-white border border-solid border-grey-20 py-6 px-8">
        <h2 class="text-blue-60 font-bold text-2xl leading-none mb-8 md:text-3xl">
            Most popular locations for recruitment agencies
        </h2>
        <div class="flex flex-col mb-2 md:grid md:grid-cols-3 md:grid-flow-col md:grid-rows-3">
            <static-search-link
                class="text-blue-30 leading-10 hover:text-blue-60"
                v-for="location in popularLocations"
                :key="location.name"
                :to="location.url"
                :title="location.name">
                {{ location.name }}
            </static-search-link>
        </div>
        <p>
            Don't see your town?
            <static-search-link class="text-blue-30 hover:text-blue-60"
                                to="/agencysearch/bylocation.htm">View all locations
            </static-search-link>
        </p>

        <h2 class="text-blue-60 font-bold text-2xl leading-none mb-8 mt-16 md:text-3xl">
            Most popular industries for recruitment agencies
        </h2>
        <div class="flex flex-col mb-2 md:grid md:grid-cols-3">
            <static-search-link
                class="text-blue-30 leading-10 hover:text-blue-60"
                v-for="industry in industryLinks"
                :key="industry.name"
                :to="industry.url"
                :title="industry.name"
            >
                {{ industry.name }}
            </static-search-link>
        </div>
        <p>
            Don't see your industry?
            <span class="text-blue-30 cursor-pointer hover:text-blue-60"
                  v-if="!showAllIndustries"
                  @click="toggleShowAllIndustries"
            >
                Show all industries
            </span>
            <span class="text-blue-30 cursor-pointer hover:text-blue-60"
                  v-else
                  @click="toggleShowAllIndustries"
            >
                Show most popular industries
            </span>
        </p>
    </div>
</template>

<script>
import StaticSearchLink from 'Components/StaticSearchLink';

export default {
    name: 'PopularLinks',
    components: {
        StaticSearchLink,
    },
    props: {
        popularLocations: {
            type: Array,
            default: [],
        },
        allIndustries: {
            type: Array,
            default: [],
        },
        popularIndustries: {
            type: Array,
            default: [],
        },
    },
    data: function () {
        return {
            showAllIndustries: false,
        };
    },
    methods: {
        toggleShowAllIndustries() {
            this.showAllIndustries = !this.showAllIndustries;
        },
    },
    computed: {
        industryLinks() {
            return this.showAllIndustries ? this.allIndustries : this.popularIndustries;
        },
    },
};
</script>
